/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import './Flyout.scss';

/**
 * PLEASE try to use the Flyout in `ba-ui-toolkit` first!
 * 
 * This is a simpler flyout which supports `alignment`
 * Supports four `position, alignment` combinations now:
 * - top, left
 * - top, right
 * - bottom, left (default)
 * - bottom, right
 * 
 * Creating this because `ba-ui-toolkit` does not support `alignment`.
 */
export const PLACEMENTS = {
	TOP: 'top',
	BOTTOM: 'bottom'
};
export const ALIGNMENTS = {
	LEFT: 'left',
	RIGHT: 'right'
};

class Flyout extends Component {

	constructor(props) {
		super(props);
		this.state = {
			position: {
				x: 0,
				y: 0
			}
		};
		this._flyout = React.createRef();
	}

	componentDidMount() {
		this._updateLocation();
		window.addEventListener('resize', this._updateLocation.bind(this));
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._updateLocation.bind(this));
	}

	render() {
		return (
			<div
				ref={this._flyout}
				className={`exploreFlyout ${this.props.className}`}
				style={{
					top: `${this.state.position.y}px`,
					left: `${this.state.position.x}px`
				}}
			>
				{ this.props.children }
			</div>
		);
	}

	_updateLocation() {
		if(!this._flyout.current) {
			return;
		}
		const { triggerNode, placement, alignment } = this.props;
		const triggerNodeRect = triggerNode.getBoundingClientRect();
		const flyoutRect = this._flyout.current.getBoundingClientRect();
		let x, y;
		if(alignment === ALIGNMENTS.LEFT) {
			x = triggerNodeRect.left;
			if ((window.innerWidth - x) < flyoutRect.width) {
				x = window.innerWidth - flyoutRect.width;
			}
		} else if(alignment === ALIGNMENTS.RIGHT) {
			x = triggerNodeRect.left + triggerNodeRect.width - flyoutRect.width;
			if(x < 0) {
				x = 0;
			}
		}

		if(placement === PLACEMENTS.TOP){
			y = triggerNodeRect.top - flyoutRect.height - 1;
			if(y < 0) {
				y = 0;
			}
		} else if(placement === PLACEMENTS.BOTTOM) {
			y = triggerNodeRect.top + triggerNodeRect.height + 1;
			if ((window.innerHeight - y) < flyoutRect.height) {
				y = window.innerHeight - flyoutRect.height;
			}
		}

		this.setState({
			position: {
				x,y
			}
		});
	}
}


Flyout.propTypes = {
	className: PropTypes.string,
	triggerNode: PropTypes.element.isRequired,
	children: PropTypes.node,
	placement: PropTypes.oneOf(Object.values(PLACEMENTS)),
	alignment: PropTypes.oneOf(Object.values(ALIGNMENTS))
};
Flyout.defaultProps = {
	className: '',
	placement: PLACEMENTS.BOTTOM,
	alignment: ALIGNMENTS.LEFT
};

export default Flyout;


// WEBPACK FOOTER //
// ./src/js/components/flyout/Flyout.js